import type { ReactNode } from "react";
import type { Optional } from "../../types";
import { VehicleCardDesktop } from "./vehicle-card-desktop";
import { VehicleCardMobile } from "./vehicle-card-mobile";

export enum Badges {
  BlackFair = "blackfair",
  MegaFair = "megafair",
  Featured = "featured",
}

export type VehicleCardImageProps = {
  height: number;
  width: number;
  className: string;
  src: string;
  alt: string;
  title: string;
  index: number;
  isActive: boolean;
};

export type VehicleCardProps = {
  isMobile?: Optional<boolean>;
  title: string;
  description: string;
  price: string;
  location: string;
  odometer: string;
  images?: Optional<string[]>;
  badge?: Optional<Badges>;
  inspected?: Optional<boolean>;
  view360?: Optional<boolean>;
  noPhoto?: Optional<string>;
  year?: Optional<string>;
  url?: string;
  isFavorite?: Optional<boolean>;
  isGoodDeal?: Optional<boolean>;
  isCtaWhatsApp?: Optional<boolean>;
  onFavoriteClick?: Optional<() => void | Promise<void>>;
  onButtonClick?: Optional<() => void | Promise<void>>;
  onImageRender?: Optional<(props: VehicleCardImageProps) => ReactNode>;
};

export function VehicleCard({ ...props }: Readonly<VehicleCardProps>) {
  return (
    <>
      <VehicleCardDesktop {...props} />
      <VehicleCardMobile {...props} />
    </>
  );
}
